import React from "react";
import Warning from "./styles";
import { StatsType, Contestant } from "../../../../../types/fixture";

interface Props {
  stats: StatsType[];
  eventContestants: Contestant[];
}

const FixtureWarningBox = ({ stats, eventContestants }: Props) => {
  const homeTeam = stats.find((stat) => stat.type === "home");
  const awayTeam = stats.find((stat) => stat.type === "away");
  const homeTeamTotal = homeTeam?.total;
  const awayTeamTotal = awayTeam?.total;
  const homeTeamName = eventContestants.find(
    (contestant) => contestant.position === "home"
  )?.name;
  const awayTeamName = eventContestants.find(
    (contestant) => contestant.position === "away"
  )?.name;

  return (
    <Warning data-testid="box">
      <p className="title">Fixture Info</p>
      {homeTeamTotal! <= 3 ? (
        <p className="subtext" data-testid="home-text">
          {homeTeamName} Smart Picks results calculated using data from less
          than 3 fixtures.
        </p>
      ) : null}
      {awayTeamTotal! <= 3 ? (
        <p className="subtext" data-testid="away-text">
          {awayTeamName} Smart Picks results calculated using data from less
          than 3 fixtures.
        </p>
      ) : null}
    </Warning>
  );
};

export default FixtureWarningBox;
